export const MANUFACTURING_COPY = {
  ko: {
    start: '제조 협력 요청',
    stage: '제조 단계',
    prototype: '시제품',
    production: '양산',
    queued: '요청 확인 중입니다. 처리 결과가 도착하면 갱신됩니다.',
    jobFailed: '요청을 처리하지 못했습니다. 조건을 다시 확인하거나 담당자에게 문의해 주세요.',
    paused: '현재 새 요청을 받지 않습니다. 기존 진행 상황을 확인해 주세요.',
    cancelRequest: '제조 요청 취소',
    cancelReason: '고객이 앱에서 취소를 요청했습니다.',
    cancelConfirm: '진행 중인 제조 요청을 취소할까요?',
    cancelled: '취소된 요청입니다.',
    intakeNotice:
      '제품명·수량·중량·제조 단계를 전달합니다. 레시피 배합과 연락처는 자동 전달하지 않습니다.',
    in_production: '생산 중',
    ready: '출고 준비',
    completed: '완료',
    acknowledged_factory: '공장 수락',
    approved_not_sent: '발주 승인',
    order: '주문 진행',
    retry: '다시 시도',
    syncTime: '최근 갱신',
    units: '개',
    title: '제조 협력 제안',
    refresh: '새로고침',
    waiting: '요청을 접수했습니다. 확인된 제조 제안이 여기에 표시됩니다.',
    requested: '요청 수량',
    proposed: '제안 수량',
    total: '고객 견적 총액',
    totalBasis: 'VAT·배송 포함 최종 총액',
    terms: '제안 조건',
    until: '유효 기한',
    approve: '이 조건으로 승인',
    approved: '승인 접수됨',
    unavailable: '현재 승인할 수 없는 제안입니다. 담당자 확인이 필요합니다.',
    notice:
      '승인 후 담당자가 발주 조건을 확인합니다. 이 화면에서 메일 발송이나 결제가 실행되지 않습니다.',
    confirm: '수량과 총액을 확인했나요?',
    cancel: '취소',
    error: '정보를 불러오지 못했습니다. 새로고침 후 다시 확인해 주세요.',
    loading: '제조 제안을 불러오고 있습니다.',
    failed: '처리 결과를 확인하지 못했습니다. 새로고침으로 상태를 확인한 뒤 다시 시도해 주세요.',
  },
  en: {
    start: 'Request manufacturing',
    stage: 'Manufacturing stage',
    prototype: 'Prototype',
    production: 'Production',
    queued: 'Your request is being reviewed. This page will update when processing completes.',
    jobFailed: 'The request could not be processed. Review the terms or contact our team.',
    paused: 'New requests are paused. You can still view existing progress.',
    cancelRequest: 'Cancel manufacturing request',
    cancelReason: 'Customer requested cancellation in the app.',
    cancelConfirm: 'Cancel this manufacturing request?',
    cancelled: 'This request has been cancelled.',
    intakeNotice:
      'We share the product name, quantity, unit weight and manufacturing stage. Recipe ratios and contact details are not shared automatically.',
    in_production: 'In production',
    ready: 'Ready for dispatch',
    completed: 'Completed',
    acknowledged_factory: 'Accepted by factory',
    approved_not_sent: 'Order approved',
    order: 'Order progress',
    retry: 'Try again',
    syncTime: 'Last updated',
    units: 'units',
    title: 'Manufacturing proposals',
    refresh: 'Refresh',
    waiting: 'Request received. Reviewed manufacturing proposals will appear here.',
    requested: 'Requested quantity',
    proposed: 'Proposed quantity',
    total: 'Customer total',
    totalBasis: 'Final total including VAT and shipping',
    terms: 'Terms',
    until: 'Valid until',
    approve: 'Approve these terms',
    approved: 'Approval received',
    unavailable: 'This proposal cannot currently be approved. Our team needs to review it.',
    notice:
      'Our team will confirm order terms after approval. No email or payment is executed here.',
    confirm: 'Confirm quantity and total?',
    cancel: 'Cancel',
    error: 'Could not load proposals. Refresh and try again.',
    loading: 'Loading manufacturing proposals.',
    failed: 'The action result is unknown. Refresh to check its status before retrying.',
  },
  ja: {
    start: '製造を依頼',
    stage: '製造段階',
    prototype: '試作品',
    production: '量産',
    queued: '依頼を確認中です。処理が完了すると表示を更新します。',
    jobFailed: '依頼を処理できませんでした。条件を確認するか担当者にお問い合わせください。',
    paused: '新しい依頼の受付を停止しています。進行状況は確認できます。',
    cancelRequest: '製造依頼をキャンセル',
    cancelReason: 'お客様がアプリからキャンセルを依頼しました。',
    cancelConfirm: 'この製造依頼をキャンセルしますか？',
    cancelled: 'キャンセルされた依頼です。',
    intakeNotice:
      '商品名・数量・単位重量・製造段階を共有します。配合比率や連絡先は自動送信しません。',
    in_production: '製造中',
    ready: '出荷準備完了',
    completed: '完了',
    acknowledged_factory: '工場が受諾',
    approved_not_sent: '発注承認済み',
    order: '注文の進行',
    retry: '再試行',
    syncTime: '最終更新',
    units: '個',
    title: '製造の提案',
    refresh: '更新',
    waiting: '依頼を受け付けました。確認済みの製造提案をここに表示します。',
    requested: '依頼数量',
    proposed: '提案数量',
    total: 'お客様の見積総額',
    totalBasis: '税金・送料込みの最終総額',
    terms: '条件',
    until: '有効期限',
    approve: 'この条件を承認',
    approved: '承認受付済み',
    unavailable: '現在この提案は承認できません。担当者の確認が必要です。',
    notice: '承認後、担当者が発注条件を確認します。ここではメール送信や決済は実行しません。',
    confirm: '数量と総額を確認しましたか？',
    cancel: 'キャンセル',
    error: '読み込めませんでした。更新してください。',
    loading: '製造の提案を読み込んでいます。',
    failed: '処理結果を確認できません。更新して状態を確認してから再試行してください。',
  },
  zh: {
    start: '申请制造合作',
    stage: '制造阶段',
    prototype: '样品',
    production: '量产',
    queued: '正在确认申请。处理完成后将更新此页面。',
    jobFailed: '申请未能处理。请重新确认条件或联系工作人员。',
    paused: '目前暂停接收新申请，仍可查看现有进度。',
    cancelRequest: '取消制造申请',
    cancelReason: '客户通过应用申请取消。',
    cancelConfirm: '是否取消此制造申请？',
    cancelled: '此申请已取消。',
    intakeNotice: '我们提供产品名称、数量、单位重量和制造阶段，不会自动发送配方比例或联系方式。',
    in_production: '生产中',
    ready: '待发货',
    completed: '已完成',
    acknowledged_factory: '工厂已接受',
    approved_not_sent: '订单已批准',
    order: '订单进度',
    retry: '重试',
    syncTime: '最近更新',
    units: '件',
    title: '制造合作方案',
    refresh: '刷新',
    waiting: '申请已收到。经审核的制造方案会显示在这里。',
    requested: '申请数量',
    proposed: '建议数量',
    total: '客户报价总额',
    totalBasis: '含税及运费的最终总额',
    terms: '条件',
    until: '有效期',
    approve: '批准此条件',
    approved: '已收到批准',
    unavailable: '目前无法批准此方案，需要工作人员确认。',
    notice: '批准后工作人员会确认订单条件。此页面不会发送邮件或执行付款。',
    confirm: '确认数量和总额？',
    cancel: '取消',
    error: '无法加载，请刷新重试。',
    loading: '正在加载制造方案。',
    failed: '无法确认处理结果。请刷新检查状态后再试。',
  },
} as const

export const MANUFACTURING_PORTAL_COPY = {
  ko: {
    title: 'RecipeCat 공장 포털',
    requests: '배정 요청',
    offers: '제출 견적',
    orders: '발주',
    billing: '정산',
    empty: '표시할 항목이 없습니다.',
    send: '제안 제출',
    accept: '발주 수락',
    conditions: '포함 비용·납기·제안 조건',
    amount: '공장 공급 총액 (원)',
    tax: '부가세',
    included: '포함',
    excluded: '별도',
    unknown: '미확인',
    progress: '다음 단계로 변경',
    evidence: '확인 근거',
    noAccess: '배정된 공장 계정으로 로그인해 주세요. 접근 권한은 담당자에게 문의해 주세요.',
    offline: '정보를 불러오지 못했습니다. 연결을 확인하고 다시 시도해 주세요.',
    scope: '본인 공장에 배정된 요청과 거래만 표시합니다.',
    queued: '작업을 접수했습니다. 처리 결과를 확인할 때까지 기다려 주세요.',
    language: '언어',
    refresh: '새로고침',
    fee: '합의 수수료',
    received: '적격 수취액',
    outstanding: '미수금',
    credit: '반환 예정액',
    status: '상태',
    review: '운영자 검토 대기',
    paused: '현재 공장 포털을 준비 중입니다.',
    signout: '로그아웃',
    failed: '처리하지 못했습니다. 새로고침 후 조건을 다시 확인해 주세요.',
    published: '고객 확인 대기',
    approved: '고객 승인',
    processing: '처리 중',
    succeeded: '처리 완료',
    open: '접수',
    selected: '선택됨',
    pending_review: '검토 대기',
    reviewed: '검토 완료',
    quote_approved: '고객 승인',
    order_approved: '발주 승인',
    acknowledged: '공장 수락',
    cancelled: '취소',
    rejected: '반려',
  },
  en: {
    title: 'RecipeCat factory portal',
    requests: 'Assigned requests',
    offers: 'Submitted offers',
    orders: 'Orders',
    billing: 'Settlement',
    empty: 'No items to display.',
    send: 'Submit proposal',
    accept: 'Accept order',
    conditions: 'Included costs, lead time and terms',
    amount: 'Factory supply total (KRW)',
    tax: 'VAT',
    included: 'Included',
    excluded: 'Excluded',
    unknown: 'Unconfirmed',
    progress: 'Move to next stage',
    evidence: 'Confirmation evidence',
    noAccess: 'Sign in with an assigned factory account. Contact our team for access.',
    offline: 'Could not load information. Check the connection and try again.',
    scope: 'Only requests and transactions assigned to your factory are shown.',
    queued: 'Action received. Please wait for the confirmed result.',
    language: 'Language',
    refresh: 'Refresh',
    fee: 'Agreed fee',
    received: 'Eligible receipts',
    outstanding: 'Outstanding',
    credit: 'Credit due',
    status: 'Status',
    review: 'Awaiting operator review',
    paused: 'The factory portal is being prepared.',
    signout: 'Sign out',
    failed: 'Could not process this action. Refresh and review the current terms.',
    published: 'Awaiting customer review',
    approved: 'Customer approved',
    processing: 'Processing',
    succeeded: 'Processed',
    open: 'Received',
    selected: 'Selected',
    pending_review: 'Awaiting review',
    reviewed: 'Reviewed',
    quote_approved: 'Customer approved',
    order_approved: 'Order approved',
    acknowledged: 'Factory accepted',
    cancelled: 'Cancelled',
    rejected: 'Rejected',
  },
  ja: {
    title: 'RecipeCat 工場ポータル',
    requests: '割り当てられた依頼',
    offers: '提出済み見積',
    orders: '発注',
    billing: '精算',
    empty: '表示する項目はありません。',
    send: '提案を送信',
    accept: '発注を受諾',
    conditions: '含まれる費用・納期・条件',
    amount: '工場供給総額（KRW）',
    tax: '付加価値税',
    included: '込み',
    excluded: '別途',
    unknown: '未確認',
    progress: '次の段階へ進める',
    evidence: '確認の根拠',
    noAccess:
      '割り当てられた工場アカウントでログインしてください。権限は担当者にお問い合わせください。',
    offline: '読み込めませんでした。接続を確認して再試行してください。',
    scope: 'この工場に割り当てられた依頼と取引のみ表示します。',
    queued: '操作を受け付けました。結果の確認までお待ちください。',
    language: '言語',
    refresh: '更新',
    fee: '合意手数料',
    received: '対象受取額',
    outstanding: '未払額',
    credit: '返還予定額',
    status: '状態',
    review: '運営者の確認待ち',
    paused: '工場ポータルを準備中です。',
    signout: 'ログアウト',
    failed: '処理できませんでした。更新して最新の条件を確認してください。',
    published: 'お客様の確認待ち',
    approved: 'お客様承認済み',
    processing: '処理中',
    succeeded: '処理済み',
    open: '受付済み',
    selected: '選択済み',
    pending_review: '確認待ち',
    reviewed: '確認済み',
    quote_approved: 'お客様承認済み',
    order_approved: '発注承認済み',
    acknowledged: '工場受諾済み',
    cancelled: 'キャンセル',
    rejected: '差し戻し',
  },
  zh: {
    title: 'RecipeCat 工厂门户',
    requests: '分配申请',
    offers: '已提交报价',
    orders: '订单',
    billing: '结算',
    empty: '暂无可显示的项目。',
    send: '提交方案',
    accept: '接受订单',
    conditions: '包含费用、交期及条件',
    amount: '工厂供货总额（韩元）',
    tax: '增值税',
    included: '已含',
    excluded: '另计',
    unknown: '未确认',
    progress: '更新至下一阶段',
    evidence: '确认依据',
    noAccess: '请使用已分配的工厂账号登录。有关权限，请联系工作人员。',
    offline: '无法加载信息。请检查连接后重试。',
    scope: '仅显示分配给本工厂的申请和交易。',
    queued: '操作已接收，请等待确认结果。',
    language: '语言',
    refresh: '刷新',
    fee: '约定手续费',
    received: '符合条件的实收款',
    outstanding: '未付金额',
    credit: '待返还金额',
    status: '状态',
    review: '等待运营方审核',
    paused: '工厂门户正在准备中。',
    signout: '退出登录',
    failed: '无法处理此操作，请刷新并确认最新条件。',
    published: '等待客户确认',
    approved: '客户已批准',
    processing: '处理中',
    succeeded: '已处理',
    open: '已接收',
    selected: '已选择',
    pending_review: '待审核',
    reviewed: '已审核',
    quote_approved: '客户已批准',
    order_approved: '订单已批准',
    acknowledged: '工厂已接受',
    cancelled: '已取消',
    rejected: '已退回',
  },
} as const

export function manufacturingStatusLabel(
  language: keyof typeof MANUFACTURING_COPY,
  status: string,
): string {
  const common: Record<string, string> = MANUFACTURING_COPY[language]
  const portal: Record<string, string> = MANUFACTURING_PORTAL_COPY[language]
  return common[status] ?? portal[status] ?? portal.status!
}
